import { QConfigActivityLogList } from '@exam-management/qconfig-activity-log-list';
import { Flex, PaperSection } from '@shared/components';

export default function QConfigActivityLogPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        p: theme.spacing(6),
      })}
    >
      <Flex>
        <PaperSection title='Activity Log'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              p: theme.spacing(6),
              gap: theme.spacing(6),
            })}
          >
            <QConfigActivityLogList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
